<template>
	<a :href="href" :target="target" class="console-link" @click.stop>
		<slot></slot>
	</a>
</template>

<script>
export default {
	name: 'ConsoleStep',

	props: {
		href: String,
		target: String,
	},
}
</script>

<style scoped>
.console-link {
	color: var(--gray-400);
	text-decoration: underline;
	text-align: left;
	word-break: break-all;
}
.console-link:hover:not(:active) {
	color: var(--gray-300);
}
</style>
